import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import 'rxjs/add/operator/map';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // mainUrl:any = 'http://chalkfaders.credencetech.in/';
  // mainUrl:any = 'http://dev.chalkfaders.com/api/';
   mainUrl: any = 'http://api.chalkfaders.com/';
  // mainUrl: any = 'http://localhost:3000/';
  constructor(private http: HttpClientService) { }

  signUp(user) {
    return this.http.post(this.mainUrl + 'users/register', user).map((res => res.json()));
  }

  authenticate(user) {
    return this.http.post(this.mainUrl + 'users/login', user).map((res => res.json()));
  }

  contactUs(data) {
    return this.http.post(this.mainUrl + 'users/contactUs', data).map((res => res.json()));
  }

  forgotPassword(data) {
    return this.http.post(this.mainUrl + 'users/forgotPassword', data).map((res => res.json()));
  }

  boardInitialLoadData(data) {
    return this.http.post(this.mainUrl + 'board/initialLoadData', data).map((res => res.json()));
  }

  // boardPlayerList(data){
  //   return this.http.post(this.mainUrl + 'board/playerList' ,data).map((res=>res.json()));
  // }

  playerList(data) {
    return this.http.post(this.mainUrl + 'board/playerList', data).map((res => res.json()));
  }

  trendsPlayerList(data) {
    return this.http.post(this.mainUrl + 'board/trendsPlayerList', data).map((res => res.json()));
  }

  last5PlayerList(data) {
    return this.http.post(this.mainUrl + 'board/last5PlayerList', data).map((res => res.json()));
  }

  addPlayerToManager(data) {
    return this.http.post(this.mainUrl + 'users/addPlayerToManager', data).map((res => res.json()));
  }

  playerWatch(data) {
    return this.http.post(this.mainUrl + 'users/playerWatch', data).map((res => res.json()));
  }

  removePlayerFormManager(data) {
    return this.http.post(this.mainUrl + 'users/removePlayerFromManager', data).map((res => res.json()));
  }

  updatePlatformSport(data) {
    return this.http.post(this.mainUrl + 'users/updatePersonalDetails', data).map((res => res.json()));
  }

  getProfileDetails(data) {
    return this.http.post(this.mainUrl + 'users/getProfileDetail', data).map((res => res.json()));
  }

  paymentDetails(data) {
    return this.http.post(this.mainUrl + 'users/insertPaymentDetail', data).map((res => res.json()));
  }

  playerTeamList(data) {
    return this.http.post(this.mainUrl + 'board/playerTeamList', data).map((res => res.json()));
  }

  deactiveAccount(data) {
    return this.http.post(this.mainUrl + 'users/deactivateUserAccount', data).map((res => res.json()));
  }

  logout(url, data) {
    return this.http.sociallogout(url, data).map((res => res.json()));
  }

  signinsocial(url) {
    return this.http.sociallogin(url).map((res => res.json()));
  }

  getPlayerGameLog(data) {
    return this.http.post(this.mainUrl + 'board/playerGameLog', data).map((res => res.json()));
  }

  changeOrderOfPlayerManager(data) {
    return this.http.post(this.mainUrl + 'users/changeOrderOfPlayerManager', data).map((res => res.json()));
    // return this.http.post(this.mainUrl + 'users/changeOrderOfPlayerManager', JSON.stringify(data), 'application/x-www-form-urlencoded').map((res => res.json()));
  }

  getManagerCount(data) {
    return this.http.post(this.mainUrl + 'users/getManagePlayerCount', data).map((res => res.json()));
  }
}
